window.appUtils = {}
utils = window.appUtils

# Attributes
utils.Attributes = (attributes, el) ->
    if el
        Object.keys(attributes).forEach (name, index) ->
            if name == 'class'
                el.classList.add attributes['class']...
            else
                el.setAttribute name.toString(), attributes[name]
            return
        return el
    return null

# Find Get Parameter
utils.FindGetParameter = (parameterName) ->
    result = null
    tmp = []
    window.location.search
        .substr(1)
        .split("&")
        .forEach (item) ->
            tmp = item.split("=")
            if tmp[0] == parameterName
                result = decodeURIComponent tmp[1]
    return result

# Generate ID
utils.GenerateId = (prefix) ->
    return (prefix ? "") + Date.now().toString(36) + Math.random().toString(36).substring(2, 12).padStart(12, 0)

# Is Exact Word Match With Boundary
utils.IsExactStringMatchWithBoundary = (string,match) ->
    escapeRegExpMatch = (s) ->
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
    return new RegExp("\\b#{escapeRegExpMatch(match)}\\b").test string

# Timestamp To Date
utils.TimestampToDate = (timestamp, monthAsNumber) ->
    monthAsNumber = monthAsNumber ? false
    date = new Date timestamp * 1000
    monthNames = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember']
    month = if monthAsNumber then (("0" + date.getMonth()).slice(-2) + ".") else (" " + monthNames[date.getMonth()]+ " ")
    return "#{("0" + date.getDate()).slice(-2)}.#{month}#{date.getFullYear()}"

# XML HTTP Request
utils.XMLHttpRequest = (method, url, successFunction, errorFunction, body, requestHeader) ->
    xmlHttpRequest = new XMLHttpRequest()
    xmlHttpRequest.onreadystatechange = ->
        if xmlHttpRequest.readyState == 4
            if xmlHttpRequest.status == 200
                successFunction()
            else
                if errorFunction
                    errorFunction()
    xmlHttpRequest.open method, url, true
    if body
        if typeof requestHeader != "undefined"
            if requestHeader
                xmlHttpRequest.setRequestHeader 'Content-type', requestHeader
        else
            xmlHttpRequest.setRequestHeader 'Content-type', 'application/json;charset=UTF-8'
        xmlHttpRequest.send(body)
    else
        xmlHttpRequest.send()
    
    return xmlHttpRequest